var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLoading),expression:"!isLoading"}],staticClass:"like-posts"},[_c('PostBlockShort',{attrs:{"initial-posts":_vm.posts}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }